import * as React from 'react';
import 'react-dom'; // needed to force including the package in the build
import { hot } from 'react-hot-loader';
import { Global } from '@emotion/react';
import BalanceSheet from '../BalanceSheet/BalanceSheet';
import IncomeStatement from '../IncomeStatement/IncomeStatement';
import { MultiValuesNode } from '../../types/chartDataTypes';
import globalStyles from '../../shared/theme.styles';
import { Texts } from '../../shared/context/LocaleContext';

declare let module: object;

type ChartProps = {
  data: {
    language: string;
    notesUrlFallback: string;
    notesUrlMapping: {
      [note: string]: string;
    };
    texts: Texts;
    incomeSheet?: {
      data: MultiValuesNode;
      dataColumns: string[];
      chartDataColumn: string;
      noteLabel: string;
      unitInfo: string;
    };
    balanceSheet?: {
      data: MultiValuesNode[];
      dataColumns: string[];
      noteLabel: string;
      unitInfo: string;
    };
  };
};

const Chart = ({ data }: ChartProps): React.ReactElement => (
  <div>
    <Global styles={globalStyles} />
    {data.incomeSheet && (
      <IncomeStatement
        data={data.incomeSheet.data}
        chartDataLabel={data.incomeSheet.chartDataColumn}
        dataColumns={data.incomeSheet.dataColumns}
        unitInfo={data.incomeSheet.unitInfo}
        notesLabel={data.incomeSheet.noteLabel}
        notesUrlFallback={data.notesUrlFallback}
        notesUrlMapping={data.notesUrlMapping}
        language={data.language}
        texts={data.texts}
      />
    )}
    {data.balanceSheet && (
      <BalanceSheet
        data={data.balanceSheet.data}
        dataColumns={data.balanceSheet.dataColumns}
        unitInfo={data.balanceSheet.unitInfo}
        notesLabel={data.balanceSheet.noteLabel}
        notesUrlFallback={data.notesUrlFallback}
        notesUrlMapping={data.notesUrlMapping}
        language={data.language}
        texts={data.texts}
      />
    )}
  </div>
);

export default hot(module)(Chart);
